import { Field, Int, ObjectType } from '@nestjs/graphql'

/** One top-level genre on the admin dashboard's "review campaigns per active reviewer" chart. */
@ObjectType()
export class AdminGenreSupplyDemandDto {
  @Field(type => Int)
  genreId!: number

  @Field()
  genre!: string

  @Field(type => Int)
  activeReviewerCount!: number

  @Field(type => Int)
  availableCampaignCount!: number
}
